import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-artifact",
  templateUrl: "./artifact.component.html",
  styleUrls: ["./artifact.component.scss"],
})
export class ArtifactComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
